"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Handler_1 = require("./Handler");
const Patcher_1 = require("../Patcher");
const Utils_1 = require("../../tree/Utils");
class SingleReferenceHandler extends Handler_1.Handler {
    constructor(sourceType, name, type, getCArgs) {
        super(sourceType, name);
        this.type = type;
        if (!getCArgs) {
            getCArgs = (obj) => {
                return [];
            };
        }
        this.getCArgs = getCArgs;
    }
    handle(obj, settings) {
        const value = obj[this.name];
        if (!settings) {
            obj[this.name] = undefined;
        }
        else if (Utils_1.Utils.isObjectLiteral(settings)) {
            if (settings.type && (!value || value.type !== settings.type)) {
                const cargs = this.getCArgs(obj);
                obj[this.name] = Patcher_1.Patcher.createObject(settings, this.type, ...cargs);
            }
            else {
                if (value) {
                    Patcher_1.Patcher.patchObject(value, settings);
                }
                else {
                    obj[this.name] = undefined;
                }
            }
        }
        else {
            obj[this.name] = settings;
        }
    }
}
exports.SingleReferenceHandler = SingleReferenceHandler;
//# sourceMappingURL=SingleReferenceHandler.js.map